import React from 'react';
import PropTypes from 'prop-types';
import ReactIcon from '../Icons';
import { escapeHTML } from '../../utils';

const zoomIcon = ReactIcon({ type: 'zoom_in' });

export default function Image({ row }) {
  const imageToShow = row.optimizedImageUrl || row.imageUrl;
  const originalAnswerImage = row.imageUrl;

  if (!imageToShow) {
    return '';
  }

  return (
    <div className="answer--with-image answer--matrix-open-ended-row-image">
      <div className="answer__image__container answer__image__container--radius">
        <img
          src={imageToShow}
          alt={escapeHTML(row.label)}
          className="answer__image"
        />
        <button
          type="button"
          className="answer__image__button js-zoom-image"
          data-img-src={originalAnswerImage}
        >
          {zoomIcon}
        </button>
      </div>
    </div>
  );
}

Image.propTypes = {
  row: PropTypes.object,
};
